import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { class: "mapa-wrapper" }
const _hoisted_3 = { class: "controles-custom-top-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "mapBandWidth",
  class: "mapBandWidth"
}, null, -1)

import { watch, ref, onMounted, computed } from "vue";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
import { useDisplay } from "vuetify";
import { useI18n } from "vue-i18n";
import maplibregl, { LngLatLike } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTMAPS from "@/constants/maps";
import { LABELS } from "@/constants/labels";

/********************************
 *********** SERVICES ***********
 *******************************/
import { getRajantGPS, getRajantPerfomance } from "@/services/Smartlink/Drive";

/********************************
 ********** INTERFACES **********
 *******************************/
// import { DRIVE_OBS } from "@/interfaces/SmartLink/Equipos";

import miIconoAcceso from "@/assets/Icons/solartrailer3.jpg";
import miIconoCliente from "@/assets/Icons/camion.jpg";

// 1. La lista para dibujar los checkboxes en tu <template> con v-for

export default /*#__PURE__*/_defineComponent({
  __name: 'WidthBandView',
  setup(__props) {

const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 *********** MAPLIBRE ***********
 *******************************/
const active = ref(false);

const onClickOutside = () => {
  active.value = false;
};

const activeClick = () => {
  active.value = true;
};

/**
 * Título de la vista
 */
const title = ref("Ancho de Banda");

/**
 * Ancho del mapa
 */
const width = ref("350");

/**
 * Ajustar el ancho del mapa en pantallas pequeñas
 */
watch(mdAndDown, (valor: boolean) => {
  valor ? (width.value = "100%") : (width.value = "350");
});

const listaEquipos = ref<any[]>([]);

// ==========================================
// 1. FUNCIÓN CENTRAL QUE ACTUALIZA EL MAPA
// ==========================================
const actualizarMapaGeoJSON = () => {
  // Diagnóstico 1: ¿Existe la instancia del mapa y la fuente?
  if (!mapBandWidth) {
    console.error("🛑 DEBUG: La variable 'map' es null o undefined.");
    return;
  }
  if (!mapBandWidth.getSource("equipos-source")) {
    console.warn(
      "⚠️ DEBUG: La fuente 'equipos-source' aún no existe en el mapa.",
    );
    return;
  }

  const equiposVisibles = listaEquipos.value.filter((e) => e.visible);

  const features = equiposVisibles.map((equipo) => {
    // Diagnóstico 3: Validar coordenadas
    if (equipo.longitud === undefined || equipo.latitud === undefined) {
      console.error(
        `🛑 DEBUG: Equipo ${equipo.name} no tiene coordenadas válidas.`,
        equipo,
      );
    }

    return {
      type: "Feature",
      geometry: {
        type: "Point",
        // RECUERDA: [Longitud, Latitud]
        coordinates: [Number(equipo.longitud), Number(equipo.latitud)],
      },
      properties: {
        name: equipo.name,
        tx: equipo.bandwidth.Tx,
        rx: equipo.bandwidth.Rx,
        icono: equipo.subtipo === "Acceso" ? "icono-acceso" : "icono-cliente",
      },
    };
  });

  mapBandWidth.getSource("equipos-source").setData({
    type: "FeatureCollection",
    features: features,
  });
};

// ==========================================
// 2. HELPERS SIMPLIFICADOS
// ==========================================
const alternarVisibilidad = () => {
  // Simplemente mandamos a redibujar el GeoJSON
  actualizarMapaGeoJSON();
};

const todosVisibles = (lista: any[]) =>
  lista.length > 0 && lista.every((e) => e.visible);

const alternarGrupo = (lista: any[], valor: boolean | null) => {
  const estado = valor === true;
  lista.forEach((equipo) => {
    equipo.visible = estado;
  });
  // Redibujamos una sola vez después de actualizar todos
  actualizarMapaGeoJSON();
};

// ==========================================
// AGRUPADOR MAESTRO CORREGIDO
// Nivel 1: Subtipo (Acceso, Distribución...) -> Nivel 2: Tipo (Camión, Trailer...)
// ==========================================
const jerarquiaEquipos = computed(() => {
  const mapa = new Map<string, Map<string, any[]>>();

  listaEquipos.value.forEach((equipo) => {
    // 1. El nivel superior ahora es el SUBTIPO (Acceso, Cliente, Distribución)
    const principal = equipo.subtipo || "Sin Categoría";

    // 2. El nivel interno ahora es el TIPO (Camión, Solar Trailer, Pila de agua)
    const secundario = equipo.tipo || "General";

    if (!mapa.has(principal)) mapa.set(principal, new Map());
    const subMapa = mapa.get(principal)!;

    if (!subMapa.has(secundario)) subMapa.set(secundario, []);
    subMapa.get(secundario)!.push(equipo);
  });

  // Transformamos los mapas a arreglos para el HTML
  return Array.from(mapa.entries()).map(([nombrePrincipal, subMapa]) => {
    const subgrupos = Array.from(subMapa.entries()).map(
      ([nombreSecundario, equipos]) => ({
        nombre: nombreSecundario,
        equipos: equipos,
      }),
    );

    // Sumamos todos los equipos de este subtipo (ej. Todos los de "Acceso") para el check general
    const equiposTotales = subgrupos.flatMap((sg) => sg.equipos);

    return {
      nombre: nombrePrincipal, // Ej: "Acceso"
      equiposTotales, // Lista plana de todos los equipos de Acceso
      subgrupos, // Ej: [{ nombre: "Camión", equipos: [...] }, { nombre: "Solar Trailer", equipos: [...] }]
    };
  });
});

function getBackgroundColorByRX(RX: number): string {
  if (RX <= 2) return "rgba(224, 70, 55, 0.7)";
  else if (RX > 2 && RX <= 10) return "rgba(249, 220, 75, 0.7)";
  else if (RX > 10) return `rgba(66, 119, 57, 0.7)`;
  else return `rgba(202, 200, 200, 0.7)`;
}

/**
 * Obtener las posiciones de los equipos Rajant
 */
async function getRajantPositions() {
  await getALLRajantPerfomance();
  await getALLRajantGPS();

  const estadoPrevio = new Map(
    listaEquipos.value.map((e: any) => [e.name, e.visible]),
  );
  const nuevaLista: any[] = [];

  allRajantArray.value.forEach((equipo: any) => {
    if (equipo.name === "" || equipo.latitud === 0 || equipo.longitud === 0)
      return; // Si no tiene datos GPS o nombre, lo saltamos

    const name = equipo.name;

    // Determinamos si debe estar visible (si es nuevo, true por defecto)
    const isVisible = estadoPrevio.has(name) ? estadoPrevio.get(name) : true;

    // Solo guardamos la data pura
    nuevaLista.push({
      ...equipo, // Guardamos todas las propiedades originales (lat, lng, tx, rx, etc)
      visible: isVisible,
      colorHalo: getBackgroundColorByRX(equipo.bandwidth.Rx),
    });
  });

  // Actualizamos la lista reactiva para que Vue dibuje los checkboxes
  listaEquipos.value = nuevaLista;

  // ==========================================
  // CONFIGURACIÓN DE LA CAPA (SYMBOL LAYER)
  // ==========================================
  const mapaInstancia = mapBandWidth.value || mapBandWidth;

  if (!mapaInstancia) {
    return;
  }

  crearFuenteYCapa(mapaInstancia);

  function crearFuenteYCapa(mapaInstancia: any) {
    if (!mapaInstancia.getSource("equipos-source")) {
      mapaInstancia.addSource("equipos-source", {
        type: "geojson",
        data: { type: "FeatureCollection", features: [] },
      });

      mapaInstancia.addLayer({
        id: "equipos-layer",
        type: "symbol",
        source: "equipos-source",
        layout: {
          "icon-image": ["get", "icono"],
          "icon-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            0.1,
            7,
            0.2,
            10,
            0.3, // A zoom 10 (lejos), el tamaño es 0.4
            15,
            0.7, // A zoom 15 (medio), el tamaño es 0.8
            20,
            1.2, // A zoom 20 (muy cerca), el tamaño es 1.5
          ],

          "text-size": [
            "interpolate",
            ["linear"],
            ["zoom"],
            5,
            2, // A zoom 5 (muy lejos), letra tamaño 5
            10,
            6, // A zoom 10, letra tamaño 10
            15,
            10, // A zoom 15, letra tamaño 13
            17,
            14, // A zoom 17, letra tamaño 14
            20,
            16, // A zoom 20, letra tamaño 17
          ],

          "icon-allow-overlap": true, // "FALSE" Si chocan 2 iconos, oculta uno
          "text-allow-overlap": true, // "FALSE" Si chocan 2 textos, oculta uno

          "text-field": [
            "concat",
            ["get", "name"],
            "\nTX: ",
            ["get", "tx"],
            " Mbps\nRX: ",
            ["get", "rx"],
            " Mbps",
          ],
          "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],

          "text-offset": [0, 1.7], // Mueve el texto debajo del icono
          "text-anchor": "top",
        },
        paint: {
          // Como no podemos usar fondos HTML, usamos un "Halo" (borde)
          // para que el texto blanco resalte sobre el mapa satelital
          "text-color": [
            "case",
            [">", ["get", "rx"], 10.0],
            "#FFFFFF",
            ["<", ["get", "rx"], 2.0],
            "#FFFFFF",
            "#000000",
          ],
          // "text-color": "#000000",
          "text-halo-color": [
            "case",
            [">", ["get", "rx"], 10.0],
            "#66BB6A", // RX > 10.0, Verde suave (mdi success)
            [">", ["get", "rx"], 2.0],
            "#FDD835", // RX > 2.0, Amarillo suave (mdi warning)
            "#EF5350", // Defecto (RX <= 2.0): Rojo suave
          ],
          "text-halo-width": 2.5,
        },
      });
    }

    // 4. Inyectamos los datos iniciales
    actualizarMapaGeoJSON();
  }
}

/**
 * Lista de los Equipos Rajant con toda su información (Ancho de Banda y GPS)
 */
const allRajantArray = ref<any>([]);

/**
 * Obtener todas las coordenadas GPS de los equipos Rajant
 */
async function getALLRajantGPS() {
  const allData = await getRajantGPS();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allRajantArray.value.forEach((item: any) => {
      allData.data.find(
        ({ ip, latitud, longitud, name, subtipo, tipo }: any) => {
          if (ip === item.ip) {
            item.name = name;
            item.latitud = latitud;
            item.longitud = longitud;
            item.subtipo = subtipo;
            item.tipo = tipo;
          }
        },
      );
    });
  }
}

/**
 * Obtener el Ancho de Banda de todos los equipos Rajant
 */
async function getALLRajantPerfomance() {
  const allData = await getRajantPerfomance();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    // const BANDWIDTH = RAJANT_PERFORMANCE;
    const BANDWIDTH = allData.data;

    BANDWIDTH.forEach((item: any) => {
      allRajantArray.value.push({
        ip: item.ip,
        name: "",
        bandwidth: JSON.parse(item.bandwidth),
        latitud: 0,
        longitud: 0,
        subtipo: "",
        tipo: "",
      });
    });
  }
}

let mapBandWidth: any = "";
const centerMap = ref<LngLatLike>([
  CONSTMAPS.longitud.value,
  CONSTMAPS.latitud.value,
]);

onMounted(async () => {
  mapBandWidth = new maplibregl.Map({
    container: "mapBandWidth",
    center: centerMap.value,
    zoom: 14,
    pitch: 40,
    bearing: 30,
    antialias: true,
    style:
      "https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF",
  });

  // const image = await mapBandWidth.loadImage(
  //   "https://maplibre.org/maplibre-gl-js/docs/assets/custom_marker.png",
  // );
  // mapBandWidth.addImage("custom-marker", image.data);
  mapBandWidth.addControl(new maplibregl.NavigationControl(), "top-right");
  mapBandWidth.addControl(new maplibregl.FullscreenControl(), "top-right");

  
  const imgAcceso = new Image(45, 45);

  imgAcceso.onload = () => {
    mapBandWidth.addImage("icono-acceso", imgAcceso);
  };

  imgAcceso.src = miIconoAcceso;

  const imgCliente = new Image(45, 45);

  imgCliente.onload = () => {
    mapBandWidth.addImage("icono-cliente", imgCliente);
  };

  imgCliente.src = miIconoCliente;

  setTimeout(() => {
    getRajantPositions();
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "mapContainer",
      onClick: activeClick
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_menu, {
            "close-on-content-click": false,
            location: "bottom start"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({ color: "#84D98E" }, props, {
                "prepend-icon": "mdi-truck",
                elevation: "2"
              }), null, 16)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                "min-width": "300",
                "max-height": "500",
                class: "overflow-y-auto mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list, { density: "compact" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_subheader, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Grupos de Equipos")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item, null, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_checkbox_btn, {
                            "model-value": todosVisibles(listaEquipos.value),
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (alternarGrupo(listaEquipos.value, $event))),
                            color: "primary"
                          }, null, 8, ["model-value"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "font-weight-bold text-white" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" MOSTRAR TODOS ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jerarquiaEquipos.value, (grupo) => {
                        return (_openBlock(), _createBlock(_component_v_list_group, {
                          key: grupo.nombre,
                          value: grupo.nombre
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              "prepend-icon": "mdi-transit-connection-variant",
                              title: grupo.nombre
                            }), {
                              append: _withCtx(() => [
                                _createElementVNode("div", {
                                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                                }, [
                                  _createVNode(_component_v_checkbox_btn, {
                                    "model-value": todosVisibles(grupo.equiposTotales),
                                    "onUpdate:modelValue": ($event: any) => (
                            alternarGrupo(grupo.equiposTotales, $event)
                          ),
                                    color: "success"
                                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ])
                              ]),
                              _: 2
                            }, 1040, ["title"])
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.subgrupos, (subgrupo) => {
                              return (_openBlock(), _createBlock(_component_v_list_group, {
                                key: subgrupo.nombre,
                                value: grupo.nombre + '-' + subgrupo.nombre
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_list_item, _mergeProps(props, {
                                    "prepend-icon": "mdi-folder-outline",
                                    title: subgrupo.nombre,
                                    class: "pl-4"
                                  }), {
                                    append: _withCtx(() => [
                                      _createElementVNode("div", {
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                                      }, [
                                        _createVNode(_component_v_checkbox_btn, {
                                          "model-value": todosVisibles(subgrupo.equipos),
                                          "onUpdate:modelValue": ($event: any) => (
                              alternarGrupo(subgrupo.equipos, $event)
                            ),
                                          color: "info"
                                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1040, ["title"])
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subgrupo.equipos, (equipo) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: equipo.name,
                                      class: "pl-12"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_checkbox_btn, {
                                          modelValue: equipo.visible,
                                          "onUpdate:modelValue": ($event: any) => ((equipo.visible) = $event),
                                          onChange: _cache[3] || (_cache[3] = ($event: any) => (alternarVisibilidad())),
                                          color: "grey-darken-2"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(equipo.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_4
      ]),
      (!active.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "mapTest"
          }))
        : _createCommentVNode("", true)
    ])), [
      [_directive_click_outside, { handler: onClickOutside }]
    ])
  ], 64))
}
}

})